/**
 * Form income popup script
 */
 class FinHub_FormIncomesPopup {
  constructor() {
    this.initState();
  }

  initState() {
    this.stepIncomesPopup = $('.incomes-popup');

    if (this.stepIncomesPopup.length) {
      this.initFormIncomes();
    }
  }

  initFormIncomes () {
    this.stepFormIncomesPopup = $('.form-incomes-popup');
    let formHelperIncomesPopup = new FinHub_FormHelper(this.stepFormIncomesPopup);
    this.addNewIncome = $('.step-income').find('.add-new-income');
    this.cancelNewIncome = this.stepIncomesPopup.find('.cancel-submit');
    this.submitPopup = this.stepFormIncomesPopup.find('.form-incomes-popup-submit');

    // Business activities
    let businessActivityIDs = [];
    this.stepFormIncomesPopup.find('input[name="income_type_id"][data-type="BUSINESS_ACTIVITY"]').each((i, field) => {
      businessActivityIDs.push($(field).val());
    });

    // Show industry
    let showIndustryIDs = [];
    this.stepFormIncomesPopup.find('input[data-show-industry="1"]').each((i, field) => {
      showIndustryIDs.push($(field).val());
    });

    // Show contract type
    let showContractTypeIDs = [];
    this.stepFormIncomesPopup.find('input[data-show-contract-type="1"]').each((i, field) => {
      showContractTypeIDs.push($(field).val());
    });

    // Show "what" fields
    let showWhatFieldIDs = [];
    this.stepFormIncomesPopup.find('input[data-show-what="1"]').each((i, field) => {
      showWhatFieldIDs.push($(field).val());
    });

    formHelperIncomesPopup.formDependencies([
      {
        field: 'settlement_type',
        dependsOn: 'input[name="income_type_id"]',
        showOn: (value) => businessActivityIDs.indexOf(value) > -1
      },
      {
        field: 'income_amount',
        dependsOn: 'input[name="income_type_id"]',
        showOn: (value) => businessActivityIDs.indexOf(value) === -1
      },
      {
        field: 'industry_id',
        dependsOn: 'input[name="income_type_id"]',
        showOn: (value) => showIndustryIDs.indexOf(value) > -1
      },
      {
        field: 'contract_type',
        dependsOn: 'input[name="income_type_id"]',
        showOn: (value) => showContractTypeIDs.indexOf(value) > -1
      },
      {
        field: 'income_other_name',
        dependsOn: 'input[name="income_type_id"]',
        showOn: (value) => showWhatFieldIDs.indexOf(value) > -1
      },
      {
        field: 'date_to',
        dependsOn: 'input[name="contract_type_id"], input[name="contract_type_id"]',
        showOn: () => {
          let selectedIncome = this.stepFormIncomesPopup.find('input[name="income_type_id"]:checked');

          if (!selectedIncome.length) {
            return false;
          }
          
          let selectedContractType = this.stepFormIncomesPopup.find('input[name="contract_type_id"]:checked');

          if (!selectedContractType.length) {
            let selectedIncomeType = selectedIncome.eq(0).attr('data-type');
            let selectedContractShowType = selectedIncome.eq(0).attr('data-show-contract-type');

            return selectedIncomeType === 'CONTRACT' && selectedContractShowType == '0';
          }

          let selectedIncomeType = selectedIncome.eq(0).attr('data-type');
          let selectedContractShowType = selectedIncome.eq(0).attr('data-show-contract-type');
          let selectedContractTypeShowDateTo = selectedContractType.eq(0).attr('data-show-date-to');
          
          return (
            selectedIncomeType === 'CONTRACT' && 
            selectedContractShowType == '1' && 
            selectedContractTypeShowDateTo === '1'
          ) || (
            selectedIncomeType === 'CONTRACT' &&
            selectedContractShowType == '0'
          );
        }
      },
      {
        field: 'currency',
        dependsOn: 'input[name="income_type_id"], input[name="settlement_type_id"]',
        showOn: () => {
          let incomeType = this.stepFormIncomesPopup.find('input[name="income_type_id"]:checked');

          if (incomeType.length && businessActivityIDs.indexOf(incomeType.eq(0).val()) === -1) {
            return true;
          }

          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
        }
      },
      {
        field: 'revenue_amount_current_year',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
        }
      },
      {
        field: 'revenue_amount_last_year',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
        }
      },
      {
        field: 'income_amount_current_year',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER';
        }
      },
      {
        field: 'income_amount_last_year',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER';
        }
      },
      {
        field: 'billing_number_current_year',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
        }
      },
      {
        field: 'tax_rate',
        dependsOn: 'input[name="settlement_type_id"]',
        showOn: () => {
          let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');

          if (!selectedSettlement.length) {
            return false;
          }

          let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
          return selectedSettlementType === 'LUMP_SUM' || selectedSettlementType === 'FIXED_AMOUNT_TAX';
        }
      },      
      {
        field: 'currency_other_name',
        dependsOn: 'select[name="currency_id"]',
        showOn: () => {
          let selectedCurrency = this.stepFormIncomesPopup.find('select[name="currency_id"]').find(":selected");

          if (!selectedCurrency.length) {
            return false;
          }

          let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
          return selectedCurrencyCode === 'OTHER';
        }
      }
    ]);

    this.addNewIncome.on('click', e => {
      e.preventDefault();
      this.stepIncomesPopup.removeClass('is-hidden');
    });

    this.cancelNewIncome.on('click', e => {
      e.preventDefault();
      this.stepIncomesPopup.addClass('is-hidden');
      this.stepFormIncomesPopup[0].reset();
      $("*[data-fh-name]").addClass('is-hidden');
    });

    this.submitPopup.on('click', e => {
      e.preventDefault();
      let result = formHelperIncomesPopup.formValidate();

			if (result) {
        let serializedData = this.stepFormIncomesPopup.serializeArray();
        serializedData = this.serializeArrayToJSON(serializedData);
        $(document).trigger('finhub-add-income', serializedData);
        this.cancelNewIncome.trigger('click');
			}
    });
  }

  serializeArrayToJSON (arrayToConvert) {
    let outputJSON = {};

    for (let i = 0; i < arrayToConvert.length; i++) {
      let pair = arrayToConvert[i];

      if (pair.value === '' || pair.value === null) {
        continue;
      }
      
      outputJSON[pair.name] = pair.value;
    }

    return JSON.stringify(outputJSON);
  }
}